module.exports = __webpack_public_path__ + "img/plant.bedd9cd9.png";